(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ── FIX SCROLL NUCLÉAIRE ── */
  (function() {
    var scrollY = 0;

    function unlockScroll() {
      var b = document.body;
      var h = document.documentElement;
      b.style.removeProperty('overflow');
      b.style.removeProperty('position');
      b.style.removeProperty('top');
      b.style.removeProperty('left');
      b.style.removeProperty('width');
      b.style.removeProperty('height');
      h.style.removeProperty('overflow');
      h.style.removeProperty('overflow-y');
      h.style.removeProperty('position');
      h.classList.remove('overflow-hidden', 'no-scroll', 'is-locked');
      b.classList.remove('overflow-hidden', 'no-scroll', 'is-locked', 'menu-open');
      if (scrollY > 0) { window.scrollTo(0, scrollY); }
    }

    function lockScroll() { scrollY = window.scrollY; }

    var details = document.getElementById('Details-menu-drawer-container');
    if (details) {
      details.addEventListener('toggle', function() {
        if (this.open) {
          lockScroll();
        } else {
          unlockScroll();
          setTimeout(unlockScroll, 50);
          setTimeout(unlockScroll, 150);
          setTimeout(unlockScroll, 300);
          setTimeout(unlockScroll, 500);
        }
      });
    }

    new MutationObserver(function() {
      var d = document.getElementById('Details-menu-drawer-container');
      if (!d || d.open) return;
      var b = document.body;
      var h = document.documentElement;
      var isLocked =
        b.style.overflow === 'hidden' ||
        b.style.position === 'fixed' ||
        h.style.overflow === 'hidden' ||
        b.classList.contains('overflow-hidden') ||
        b.classList.contains('no-scroll') ||
        b.classList.contains('is-locked');
      if (isLocked) unlockScroll();
    }).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'], subtree: false });

    new MutationObserver(function() {
      var d = document.getElementById('Details-menu-drawer-container');
      if (!d || d.open) return;
      if (document.documentElement.style.overflow === 'hidden') { unlockScroll(); }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });

    document.addEventListener('click', function(e) {
      if (e.target.closest('.menu-drawer__close-btn') || e.target.closest('[data-close-drawer]')) {
        setTimeout(unlockScroll, 50);
        setTimeout(unlockScroll, 200);
        setTimeout(unlockScroll, 400);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        setTimeout(unlockScroll, 50);
        setTimeout(unlockScroll, 200);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
